import { queryOptions } from '@tanstack/react-query';
import type { PaginationState, SortingState } from '@tanstack/table-core';

import { getById, getProductCategories } from '../api/category';
import type { CategoryListingFilters } from '../models/category';

export const categoryQueryKeys = {
	all: ['categories'],
	list: () => [...categoryQueryKeys.all, 'list'],
	listPage: (
		pagination: PaginationState,
		filters: CategoryListingFilters,
		sorting: SortingState | undefined,
	) => [...categoryQueryKeys.list(), pagination, sorting, filters],
	getById: (id: number) => [...categoryQueryKeys.all, id],
} as const;

export const categoryQueries = {
	all: queryOptions({
		queryKey: categoryQueryKeys.all,
		queryFn: ({ signal }) => getProductCategories(signal),
		staleTime: Infinity,
	}),
	getById: (id: number) =>
		queryOptions({
			queryKey: categoryQueryKeys.getById(id),
			queryFn: ({ signal }) => getById(id, signal),
		}),
};
